import { put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { GET_INTERVIEW_CONFIG } from "@/constants/ActionTypes";
import { getInterviewConfigAPI } from "@/api/interviewConfig.api";
import {
  EErrorLevel,
  EErrorSource,
  errorLogger,
} from "@/utils/ubaTracking.utils";
import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import {
  GET_INTERVIEW_CONFIG_API_HTTP_STATUS_CODES,
  GET_INTERVIEW_CONFIG_ERROR_MESSAGE,
} from "@/constants/InterviewConfigConstants";
import { showToast } from "@/actions/appStatus.action";
import {
  setApiCallError,
  setApiCallInProgress,
  setApiCallSuccess,
} from "@/actions/apiCallStatus.action";
import { GET_INTERVIEW_CONFIG_API } from "@/constants/ApiNameConstants";
import { IGetInterviewConfigAction } from "@/types/interviewConfig.types";
import { call } from "./utils.saga";

function* getInterviewConfig({
  payload: { interviewSlug },
}: IGetInterviewConfigAction) {
  try {
    yield put(setApiCallInProgress(GET_INTERVIEW_CONFIG_API));
    const response = yield* call(getInterviewConfigAPI, interviewSlug);
    yield put({
      type: `${GET_INTERVIEW_CONFIG}_SUCCESS`,
      payload: {
        interviewConfig: response.data,
      },
    });
    yield put(setApiCallSuccess(GET_INTERVIEW_CONFIG_API));
  } catch (error) {
    yield put(setApiCallError(GET_INTERVIEW_CONFIG_API));
    errorLogger(error as Error, EErrorLevel.LOW, EErrorSource.API, {}, {});

    if (axios.isAxiosError(error)) {
      const message = yield* call(
        apiErrorHandler,
        error,
        GET_INTERVIEW_CONFIG_API_HTTP_STATUS_CODES,
        GET_INTERVIEW_CONFIG_ERROR_MESSAGE,
      );
      if (message)
        yield put(
          showToast({
            message,
            type: EToastType.ERROR,
          }),
        );
    }
  }
}

export default function* loadInterviewConfigSaga() {
  yield takeLatest(GET_INTERVIEW_CONFIG, getInterviewConfig);
}
